import styled from "styled-components";

export const HeaderTitle = styled.div`
	${({ theme }) => theme.textStyles.headersTitle}
`;

export const Title = styled.div`
	${({ theme }) => theme.textStyles.title}
`;

export const Subtitle = styled.div`
	${({ theme }) => theme.textStyles.subtitle}
`;
